import Modal from "../Modal/Modal";
import "./ImportModal.scss";
import { useState } from "react";
import { InputFile } from "../Inputs/Inputs";
import { api } from "../../api/api";
import { useToast } from "../Toast";
import objToFormdata from "../../utils/objToFormdata";
import { Button, Header, Icon, Loader, Segment } from "semantic-ui-react";
import { DownloadIcon } from "lucide-react";

const initialState = {
  file: "",
};

const ImportModal = ({ api_url, file_name, refetch }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [data, setData] = useState(initialState);
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (loading) return;

    try {
      setError({});
      setLoading(true);

      const res = await api.post(
        `${api_url}import_csv/`,
        objToFormdata(data),
        {
          responseType: "blob",
        }
      );

      const type =
        res.headers["content-type"];

      // file response
      if (
        type?.includes("sheet") ||
        type?.includes("csv") ||
        type?.includes("octet-stream")
      ) {
        const url =
          window.URL.createObjectURL(
            new Blob([res.data])
          );

        const a =
          document.createElement("a");

        a.href = url;

        a.download =
          res.headers[
            "content-disposition"
          ]
            ?.split("filename=")[1]
            ?.replace(/"/g, "") ||
          "error_file.xlsx";

        a.click();
        toast.open(
          "File import failed",
          "error"
        );
        return;
      }

      toast.open(
        "File Imported successfully",
        "success"
      );

      refetch();
      setModalOpen(false);
      setData(initialState);
    } catch (err) {
      console.error(err);

      setError({
        file: "Something went wrong.",
      });

    } finally {
      setLoading(false);
    }
  };
  const download = async () => {
    try {
      setLoading(true);
      const res = await api.get(
        `${api_url}download_empty_xcl/?file_name=${file_name}`,
        { responseType: "blob" }, // 👈 key switch
      );

      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `${file_name}.xlsx`; // auto filename
      document.body.appendChild(a);
      a.click(); // 👈 auto-download happens here
      a.remove();

      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
      toast.open("Excel export failed", "error");
    } finally {
      setLoading(false);
    }
  };
  return (
    <Modal
      open={modalOpen}
      onOpen={() => {
        setModalOpen(true);
        setData(initialState)
      }}
      trigger={
        <button className="btn btn-approve"
          style={{
            gap: 3
          }}
        >

          <DownloadIcon size={15} />

          Import
        </button>
      }
      className="modal-window upload-modal-wrapper"
    >
      <div
        className="close-btn"
        onClick={() => {
          setModalOpen(false);
          setError({
            file: "",
          });
        }}
      >
        &#10005;
      </div>
      <Segment
        padded="large"
        style={{
          marginTop: "20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* Left Content */}
        <div>
          <Header as="h3" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Icon name="file excel outline" size="big" />
            Sample Format
          </Header>

          <p style={{ color: "rgba(0,0,0,0.6)", fontSize: "14px" }}>
            You can download the attached template and use them as a
            starting point of your own file
          </p>
        </div>

        {/* Right Button */}
        <Button
          circular
          icon
          onClick={download}
          disabled={loading}
          style={{ padding: "16px" }}
        >
          {loading ? (
            <Loader active inline size="small" />
          ) : (
            <Icon name="download" />
          )}
        </Button>
      </Segment>

      <div className="title">Select Your File</div>
      <div>
        <InputFile
          label="File to upload"
          error={error["file"]}
          value={data.file}
          onChange={(v) => setData({ file: v })}
          required
        />
      </div>
      <button
        className="btn import-submit-btn"
        disabled={loading}
        onClick={handleSubmit}
      >
        Import
      </button>
    </Modal>
  );
};

export default ImportModal;
